import { LocationsLabels } from 'libs/shared-lib/interfaces/partner-web/locations';
import { m070c040DealerContact } from '../../shared/shared.it';

export const LOCATIONS_LABELS_IT: LocationsLabels = {
    headline: 'Le nostre sedi competenti',
    m070c040DealerContact,
};
